import React from 'react';
import { Box } from '@mui/material';
import { AppBottomNavigation } from './BottomNavigation';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: 'background.default',
        paddingBottom: '80px', // Space for bottom navigation
      }}
    >
      {children}
      <AppBottomNavigation />
    </Box>
  );
};